import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface TimePickerProps {
    value: string;
    onChange: (value: string) => void;
    emptyDefault?: string;
    disabled?: boolean;
    fullWidth?: boolean;
}

export function TimePicker({ value, onChange, emptyDefault, disabled, fullWidth }: TimePickerProps) {
    const normalized = value?.slice(0, 5) || '';

    return (
        <StyledInput
            type="time"
            value={normalized}
            onChange={(e) => onChange(e.target.value + ':00')}
            onFocus={() => {
                if (!normalized && emptyDefault) onChange(emptyDefault + ':00');
            }}
            disabled={disabled}
            $fullWidth={fullWidth}
        />
    );
}

const StyledInput = styled('input', { shouldForwardProp: (prop) => prop !== '$fullWidth' })<{ $fullWidth?: boolean }>(
    ({ $fullWidth }) => ({
        padding: '10px 14px',
        fontSize: 14,
        color: Colors.primary,
        backgroundColor: Colors.fill,
        border: `1px solid ${Colors.border}`,
        borderRadius: 10,
        outline: 'none',
        boxSizing: 'border-box',
        width: $fullWidth ? '100%' : undefined,
        minWidth: $fullWidth ? 0 : undefined,
        '&:focus': {
            borderColor: Colors.border,
        },
        '&:disabled': {
            backgroundColor: Colors.fill,
            color: Colors.textSecondary,
        },
    }),
);
